import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigationMode } from '@context/NavigationModeContext'

import { ArrowLeftRightIcon } from '@ui/icons/ArrowLeftRight.icon'

import { MenuSection } from '@shared/components/Navigation/menuSections/useMenuSections'

export const ACCOUNT_SWITCH_MENU_ID = {
  PERSONAL: 'account-personal',
  PARTNER: 'account-partner',
}

export const useAccountSwitchMenu = (handleAccountSwitch: () => void): MenuSection => {
  const { t } = useTranslation()
  const { navigationMode } = useNavigationMode()

  return useMemo(
    () => ({
      id: 'account-switch',
      label: t('Tabs.Account Switch'),
      icon: ArrowLeftRightIcon,
      children: [
        {
          id: ACCOUNT_SWITCH_MENU_ID.PERSONAL,
          label: t('Tabs.Trader'),
          onClick: navigationMode !== 'trader' ? handleAccountSwitch : undefined,
          isSelected: navigationMode === 'trader',
        },
        {
          id: ACCOUNT_SWITCH_MENU_ID.PARTNER,
          label: t('Tabs.Partner'),
          onClick: navigationMode !== 'partner' ? handleAccountSwitch : undefined,
          isSelected: navigationMode === 'partner',
        },
      ],
    }),
    [t, handleAccountSwitch, navigationMode]
  )
}
